import { HttpContext, HttpContextToken } from '@angular/common/http';

export const SUPPRESS_SUCCESS_SNACKBAR = new HttpContextToken<boolean>(() => false);

export const SUPPRESS_ERROR_SNACKBAR = new HttpContextToken<boolean>(() => false);

export function inlineFeedbackContext(): HttpContext {
  return new HttpContext().set(SUPPRESS_SUCCESS_SNACKBAR, true).set(SUPPRESS_ERROR_SNACKBAR, true);
}
